<div class="container">

  <div class="btn_new">
    <button type="button" pButton label="Novo Contéudo" (click)="openEditDialog()"></button>
  </div>
  <ng-container *ngIf="pagination.data?.length; else noData">
    <div class="content-list">
      <div
        *ngFor="let item of pagination.data"
        class="content-card"
        (click)="openEditDialog(item)"
      >
        <div class="card-header">
          <i
            class="pi"
            [ngClass]="getIconByTipo(item.gestaoPaginaTipoDadoENUM)"
          ></i>

          <span class="content-type">
            {{ item.gestaoPaginaTipoDado }} - {{ item.gestaoPagina }}
          </span>
        </div>

        <div class="card-body">
          <p class="content-value">
            {{ item.valor }}
          </p>

          <span class="content-date">
            <i class="pi pi-calendar"></i>
            {{ item.dataCriacaoFormatada }}
          </span>
        </div>
      </div>
    </div>

    <div class="pagination-controls">
      <app-paginator-control
        [first]="
          ((pagination.pageNumber ?? 1) - 1) * (pagination.pageSize ?? 10)
        "
        [rows]="pagination.pageSize ?? 10"
        [totalRecords]="pagination.totalRecords ?? 0"
        (pageChange)="onPageChange($event)"
      >
      </app-paginator-control>
    </div>
  </ng-container>

  <ng-template #noData>
    <div class="nodata">
      <app-data-void
        titulo="Nenhum donteúdo encontrado"
        descricao="Adicione um novo conteúdo"
      ></app-data-void>
    </div>
  </ng-template>
</div>

<p-dialog
  header="Editar Conteúdo"
  [(visible)]="displayDialog"
  [modal]="true"
  [style]="{ width: '450px' }"
  [closable]="true"
>
  <form [formGroup]="form" (ngSubmit)="submit()" class="p-fluid grid">
    <!-- Tipo de Página -->
    <div class="field col-12 flex flex-column gap-2">
      <label for="GestaoPaginaENUM">Conteúdo da página</label>
      <p-select
        [options]="paginaOptions"
        formControlName="GestaoPaginaENUM"
        optionLabel="label"
        optionValue="id"
        showClear="true"
        placeholder="Seleccione o tipo de conteúdo"
        appendTo="body"
      ></p-select>
      <small *ngIf="isInvalid('GestaoPaginaENUM')" class="p-error">
        conteúdo é obrigatório
      </small>
    </div>

    <!-- Tipo de Dado -->
    <div class="field col-12 flex flex-column gap-2">
      <label for="GestaoPaginaTipoDadoENUM">Tipo de Dado</label>
      <p-select
        [options]="tipoDadoOptions"
        formControlName="GestaoPaginaTipoDadoENUM"
        optionLabel="label"
        optionValue="id"
        placeholder="Seleccione o tipo de dado"
        appendTo="body"
        showClear="true"
      ></p-select>
      <small *ngIf="isInvalid('GestaoPaginaTipoDadoENUM')" class="p-error">
        Tipo de dado é obrigatório
      </small>
    </div>

    <!-- Valor (dinâmico) -->
    <div class="field col-12 flex flex-column gap-2">
      <label for="Valor">Valor</label>
      <input pInputText type="text" formControlName="Valor" />
      <small *ngIf="isInvalid('Valor')" class="p-error">
        Valor é obrigatório
      </small>
    </div>

    <div class="flex justify-content-between w-full">
      <button
        pButton
        type="button"
        label="Cancelar"
        severity="secondary"
        (click)="closeDialog()"
      ></button>

      <button
        pButton
        type="submit"
        label="Salvar"
        severity="success"
        [disabled]="form.invalid"
      ></button>
    </div>
  </form>
</p-dialog>
